import { render } from "./SchedaAzienda.vue?vue&type=template&id=1f986966"
import script from "./SchedaAzienda.vue?vue&type=script&lang=js"
export * from "./SchedaAzienda.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__